/**
 * Admin Users Page
 * System-wide user management for administrators
 */

import { createFileRoute } from '@tanstack/react-router'
import { useTranslation } from '@spcc/core'
import { AdminUsersSection } from '@spcc/domains/users'

export const Route = createFileRoute('/admin/users')({
  component: UsersPage,
})

function UsersPage() {
  const { t } = useTranslation()

  return (
    <div className="flex flex-col gap-6 p-6">
      <div>
        <h1 className="text-2xl font-bold text-foreground">
          {t('admin.users.title', 'User Management')}
        </h1>
        <p className="text-muted-foreground mt-1">
          {t('admin.users.subtitle', 'Manage users across all tenants')}
        </p>
      </div>
      <AdminUsersSection />
    </div>
  )
}
